import { Routes, Route } from "react-router-dom";
import { CopilotProvider } from "@/components/copilot-provider";
import { Shell } from "@/components/Shell";
import { SyncProvider } from "@/components/SyncProvider";
import { HomePage } from "@/pages/HomePage";
import { MapPage } from "@/pages/MapPage";
import { DownloadsPage } from "@/pages/Downloads";
import { SettingsPage } from "@/pages/SettingsPage";
import { Chat } from "@/pages/Chat";

export function App() {
  return (
    <CopilotProvider>
    <SyncProvider>
    <Shell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/downloads" element={<DownloadsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        {/* /spot opens the map — spot detail via SpotSheet overlay */}
        <Route path="/spot" element={<MapPage />} />
      </Routes>
    </Shell>
    </SyncProvider>
    </CopilotProvider>
  );
}
